import { CaretDownIcon } from '@phosphor-icons/react'
import {
    ScoopAccordion,
    ScoopAccordionSummary,
    ScoopAccordionDetails,
    ScoopText,
} from '../../../../../../ui'
import styles from './FormSection.module.scss'

/**
 * FormSection - Accordion wrapper for form sections
 *
 * @param {string} title - Section title
 * @param {string} description - Optional section description
 * @param {React.ReactNode} children - Section content
 * @param {boolean} defaultExpanded - Whether to start expanded (default: true)
 * @param {boolean} optional - Whether this section is optional (shows "(Optional)" tag)
 * @param {string} className - Additional CSS classes
 */
export const FormSection = ({
    title,
    description,
    children,
    defaultExpanded = true,
    optional = false,
    className = '',
}) => {
    return (
        <ScoopAccordion
            defaultExpanded={defaultExpanded}
            className={`${styles.section} ${className}`}
        >
            {({ expanded, onToggle }) => (
                <>
                    <ScoopAccordionSummary
                        onClick={onToggle}
                        expandIcon={<CaretDownIcon size={16} weight="bold" />}
                        className={styles.summary}
                    >
                        <div className={styles.headerContent}>
                            <ScoopText className={styles.title}>{title}</ScoopText>
                            {optional && (
                                <ScoopText className={styles.optionalTag}>(Optional)</ScoopText>
                            )}
                        </div>
                    </ScoopAccordionSummary>
                    <ScoopAccordionDetails className={styles.details}>
                        {description && (
                            <ScoopText className={styles.description}>{description}</ScoopText>
                        )}
                        <div className={styles.content}>{children}</div>
                    </ScoopAccordionDetails>
                </>
            )}
        </ScoopAccordion>
    )
}
